import React, { useContext, useState } from "react";
import { UserContext } from "../context/UserContext";
import { User, Mail, Save, CheckCircle2 } from "lucide-react";

const Profile = () => {
  const { user, setUser } = useContext(UserContext);
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [saved, setSaved] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setUser({ name, email });
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-12">
      <div className="text-center mb-10">
        <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-3xl flex items-center justify-center text-white text-4xl font-bold shadow-xl shadow-blue-500/20 mx-auto mb-4 animate-float">
          {user.name.charAt(0)}
        </div>
        <h2 className="text-3xl font-bold text-slate-900">Account Settings</h2>
        <p className="text-slate-500">Manage your profile and account preferences</p>
      </div>

      <div className="glass-card rounded-3xl p-6 sm:p-8 border border-white/40 shadow-xl shadow-slate-900/5">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2 px-1 flex items-center gap-2">
              <User size={16} className="text-slate-400" />
              Full Name
            </label>
            <input
              className="input-field"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
            />
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2 px-1 flex items-center gap-2">
              <Mail size={16} className="text-slate-400" />
              Email Address
            </label>
            <input
              className="input-field"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
            />
          </div>

          <div className="pt-4">
            <button
              type="submit"
              className={`w-full !py-4 btn-primary flex items-center justify-center gap-2 ${
                saved ? "bg-green-600 hover:bg-green-700 shadow-green-500/20" : "bg-blue-600 hover:bg-blue-700 shadow-blue-500/20"
              }`}
            >
              {saved ? (
                <>
                  <CheckCircle2 size={20} />
                  Changes Saved!
                </>
              ) : (
                <>
                  <Save size={20} />
                  Save Changes
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      <div className="mt-12 glass-card rounded-3xl p-6 sm:p-8 border border-white/40 bg-slate-50/50">
        <h3 className="text-lg font-bold text-slate-900 mb-4">Account Security</h3>
        <p className="text-slate-500 text-sm mb-6">
          Manage your password and security settings to keep your account safe.
        </p>
        <button className="text-blue-600 font-semibold text-sm hover:text-blue-700 transition-colors">
          Change Password &rarr;
        </button>
      </div>
    </div>
  );
};

export default Profile;

